export type DoseLogIdentity = {
  patientMedicationId?: string | null;
  medicationName?: string | null;
};

export function sameMedication(
  log: DoseLogIdentity,
  medication: { medicationId?: string | null; medicationName?: string | null },
) {
  const normalizedName = medication.medicationName?.trim().toLowerCase();
  const medId = medication.medicationId ?? null;

  // When both sides carry an id, trust it as the sole decider. The name
  // fallback is only for legacy rows / logs that have no id to compare —
  // two patients medications can share a display name and must not reconcile.
  if (medId && log.patientMedicationId) {
    return log.patientMedicationId === medId;
  }
  if (
    normalizedName &&
    log.medicationName?.trim().toLowerCase() === normalizedName
  ) {
    return true;
  }
  return false;
}
